import { gql } from '@apollo/client';

import type { WorkProgressBagCustomerOption } from './getWorkProgressBagCustomerSummaryPage';

/**
 * 「大包差异」tab 主表查询。
 *
 * 与「包裹差异」tab 同形但**只取大包口径字段**：服务端类型仍为
 * `WorkProgressBagCustomerSummaryPageType`，但本查询只 select bag 相关字段；
 * 前端类型 [WorkProgressBagDiffCustomerSummaryRow] / [WorkProgressBagDiffSummaryAggregate]
 * 也只声明 bag 字段，避免与包裹差异 tab 的 [WorkProgressBagCustomerSummaryRow] 混淆。
 */
export const GET_WORK_PROGRESS_BAG_DIFF_CUSTOMER_SUMMARY_PAGE = gql`
  query GetWorkProgressBagDiffCustomerSummaryPage($filter: WorkProgressBagDiffCustomerSummaryFilterInput!) {
    getWorkProgressBagDiffCustomerSummaryPage(filter: $filter) {
      content {
        customerId
        customerName
        onlyNoMawbBreakdownRows
        expectedBagCountSum
        inboundBagCountSum
        bagDiffSum
        bagDiffRate
      }
      aggregate {
        expectedBagCountSum
        inboundBagCountSum
        bagDiffSum
        bagDiffRate
      }
      allCustomers {
        customerId
        customerName
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
      dataCalculatedAtMax
    }
  }
`;

export interface WorkProgressBagDiffCustomerSummaryFilterInput {
  prePickupHubId: number;
  arrivalDateStart?: string | null;
  arrivalDateEnd?: string | null;
  customerId?: number | null;
  page?: number;
  pageSize?: number;
  sortField?: 'BAG_DIFF' | 'EXPECTED_BAG_COUNT' | 'INBOUND_BAG_COUNT' | null;
  sortDirection?: 'ASC' | 'DESC' | null;
}

export interface WorkProgressBagDiffCustomerSummaryRow {
  customerId: number;
  customerName: string;
  onlyNoMawbBreakdownRows?: boolean;
  expectedBagCountSum: number;
  inboundBagCountSum: number;
  bagDiffSum: number;
  bagDiffRate: number;
}

export interface WorkProgressBagDiffSummaryAggregate {
  expectedBagCountSum: number;
  inboundBagCountSum: number;
  bagDiffSum: number;
  bagDiffRate: number;
}

export interface GetWorkProgressBagDiffCustomerSummaryPageResponse {
  getWorkProgressBagDiffCustomerSummaryPage: {
    content: WorkProgressBagDiffCustomerSummaryRow[];
    aggregate: WorkProgressBagDiffSummaryAggregate;
    allCustomers: WorkProgressBagCustomerOption[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
    dataCalculatedAtMax?: string | null;
  };
}
